import { ChevronDown } from 'lucide-react'
import { cn } from '@/utils/cn'

/** Fundo no wrapper — tema claro força select branco via index.css */
const shellClass =
  'closer-toolbar-field-shell relative inline-flex w-fit max-w-full shrink-0 overflow-hidden rounded-xl'

const selectClass =
  'appearance-none min-h-[44px] w-auto min-w-0 [field-sizing:content] border-0 bg-transparent px-4 py-3 pr-10 text-sm font-medium text-text-secondary outline-none cursor-pointer transition-colors focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-accent/25'

type Option = { value: string; label: string }

interface CloserToolbarSelectProps {
  value: string
  onChange: (value: string) => void
  options: Option[]
  className?: string
  'aria-label'?: string
}

export function CloserToolbarSelect({
  value,
  onChange,
  options,
  className,
  'aria-label': ariaLabel,
}: CloserToolbarSelectProps) {
  const hasValue = Boolean(value)

  return (
    <div className={cn(shellClass, className)}>
      <select
        value={value}
        onChange={e => onChange(e.target.value)}
        aria-label={ariaLabel}
        className={cn(selectClass, hasValue && 'closer-toolbar-select--filled text-text-primary')}
      >
        {options.map(o => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <ChevronDown
        size={14}
        strokeWidth={2}
        className='pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-text-muted'
        aria-hidden
      />
    </div>
  )
}
